module.exports = __webpack_public_path__ + "media/images/new-ui-images/icon-5-4ebc4bd2f09f8bdb715d69bc4c1bd716.svg";